import config from './pages.json';

const organization = {
  '@type': 'SportsOrganization',
  '@id': `${config.origin}/#organization`,
  name: 'Hälsinglands Multisport',
  url: `${config.origin}/`,
  email: 'info@hälsinglandsmultisport.se',
  logo: `${config.origin}/images/hmsklogo.png`,
  address: { '@type': 'PostalAddress', addressLocality: 'Söderhamn', addressCountry: 'SE' },
  sameAs: ['https://www.facebook.com/HalsinglandsMultisport/', 'https://www.instagram.com/halsinglandsmultisport/']
};

export function structuredData(route) {
  if (route === '/') return { '@context': 'https://schema.org', ...organization };
  const races = {
    '/halsingetrailen': {
      name: 'Hälsingetrailen', image: '/images/halsingetrailen_cover.jpg',
      location: { '@type': 'Place', name: 'Segersta OKs klubbstuga vid Björktjärn',
        address: { '@type': 'PostalAddress', addressLocality: 'Segersta', addressCountry: 'SE' } }
    },
    '/stormorstrailen': {
      name: 'Stormorstrailen', image: '/images/stormorstrailen_cover.jpg',
      location: { '@type': 'Place', name: 'Hällmyra Skidstadion',
        address: { '@type': 'PostalAddress', addressLocality: 'Söderhamn', addressCountry: 'SE' } }
    }
  };
  const race = races[route];
  if (!race) return null;
  return {
    '@context': 'https://schema.org', '@type': 'SportsEvent',
    '@id': `${config.origin}${route}#event`, ...race,
    url: config.origin + route, image: config.origin + race.image,
    description: config.pages[route].description, sport: 'Terränglöpning',
    organizer: organization
  };
}

export function serializeStructuredData(data) {
  return JSON.stringify(data).replace(/</g, '\\u003c');
}
